/**
 * Character Service - работа с персонажами
 */

import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export const characterService = {
    /**
     * Получить список персонажей
     */
    getCharacters: async () => {
        return apiClient.post(ENDPOINTS.UCP.GET_CHARACTERS);
    },

    /**
     * Создать персонажа
     */
    createCharacter: async (characterData) => {
        return apiClient.post(
            ENDPOINTS.UCP.CREATE_CHARACTER,
            characterData,
            true,
            false,
        );
    },

    /**
     * Удалить персонажа
     */
    deleteCharacter: async (characterId) => {
        return apiClient.delete(ENDPOINTS.UCP.DELETE_CHARACTER, {
            character_id: characterId,
        });
    },

    /**
     * Пересдать тест персонажа
     */
    retestCharacter: async (data) => {
        // data should contain character_id and other fields (prehistory, traits, etc.)
        return apiClient.post(ENDPOINTS.UCP.RETEST_CHARACTER, data, true, true);
    },

    /**
     * Получить статистику персонажа
     */
    getStatistics: async (characterId) => {
        return apiClient.get("ucp/character-statistics", {
            character_id: characterId,
        });
    },
};

export default characterService;
